module.exports = __webpack_public_path__ + "img/client_alert.4b3e3286.svg";